import React, { useEffect, useState } from 'react';
import { leavesAPI } from '../../services/api';

const STATUS_COLOR = { pending: 'orange', approved: 'green', rejected: 'red' };

export default function HRLeaves() {
  const [leaves, setLeaves] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ status: 'approved', hr_response: '' });
  const [loading, setLoading] = useState(true);

  const load = () => leavesAPI.list().then(({ data }) => setLeaves(data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    await leavesAPI.update(selected.id, form);
    setSelected(null);
    load();
  };

  return (
    <div className="page">
      <div className="page-header"><h2>Leave Requests</h2></div>

      {loading ? <div className="page-loading">Loading...</div> : (
        <div className="card">
          <table className="data-table">
            <thead><tr><th>Employee</th><th>From</th><th>To</th><th>Reason</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {leaves.length === 0 ? (
                <tr><td colSpan={6} className="text-center text-muted">No leave requests</td></tr>
              ) : leaves.map((l) => (
                <tr key={l.id}>
                  <td>{l.user_id}</td>
                  <td>{l.start_date}</td>
                  <td>{l.end_date}</td>
                  <td>{l.reason || '—'}</td>
                  <td><span className={`badge badge-${STATUS_COLOR[l.status]}`}>{l.status}</span></td>
                  <td>
                    {l.status === 'pending' && (
                      <button className="btn btn-sm btn-primary" onClick={() => { setSelected(l); setForm({ status: 'approved', hr_response: '' }); }}>
                        Respond
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Respond to Leave Request</h3>
              <button className="modal-close" onClick={() => setSelected(null)}>×</button>
            </div>
            <div className="modal-body">
              <p><strong>{selected.start_date}</strong> to <strong>{selected.end_date}</strong></p>
              {selected.reason && <p className="text-muted">{selected.reason}</p>}
              <form onSubmit={handleUpdate}>
                <div className="form-group mt-4">
                  <label>Decision</label>
                  <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                    <option value="approved">Approve</option>
                    <option value="rejected">Reject</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Response</label>
                  <textarea rows={3} value={form.hr_response} onChange={(e) => setForm({ ...form, hr_response: e.target.value })} />
                </div>
                <div className="form-actions">
                  <button type="button" className="btn btn-ghost" onClick={() => setSelected(null)}>Cancel</button>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
